
import Table from "./CommonUserTable";


function VenueOwner() {
  return (
    <div>
      <Table role={5} />
    </div>
  );
}

export default VenueOwner;
